const urls = {
  waitroseCookies:
    '/corporate_information_home/corporate_information/legal_notices/website_cookies.html',
  homepage: '/',
};

export default urls;
